<template>
    <el-card v-loading="coverage_table_loading" class="mb-6 br-12">
        <el-row :gutter="20">
            <el-col :span="18">
                <h2 class="my-2">Coverage Activities</h2>
                <p>
                    All coverage activities
                </p>
            </el-col>
            <el-col :span="6" class="text-right">
                <div class="text-right pt-8">
                    <el-button :disabled="!hasAdminAccess || regionAccess || sub_regionAccess" type="warning" plain icon="el-icon-circle-plus-outline" class="primary-settings-button" size="small"
                        @click="openNewUpdatedCoverageActivity">Add New</el-button>
                </div>
            </el-col>
        </el-row>
        <!--
        <el-row :gutter="20" class="mt-2">
            <el-col :span="24">
                <el-table :data="updated_format_coverage_activities" style="width: 100%" max-height="400" default-expand-all>
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-row :gutter="20">
                                <el-col :span="5" class="font-bold pt-4 pb-6">
                                    Station
                                </el-col>
                                <el-col :span="5" class="font-bold pt-4 pb-6">
                                    Planning Type
                                </el-col>
                                <el-col :span="5" class="font-bold pt-4 pb-6">
                                    Order Type
                                </el-col>
                                <el-col :span="5" class="font-bold pt-4 pb-6 text-center">
                                    Activities
                                </el-col>
                                <el-col :span="2" class="font-bold pt-4 pb-6">
                                    &nbsp;
                                </el-col>
                            </el-row>
                            <el-row
                                v-for="(item, index) in scope.row.section_setup"
                                :key="'section-index-'+index"
                                :gutter="20"
                            >
                                <el-col :span="5" class="mb-4">
                                    <primary-tag>{{ item.station_name }}</primary-tag>
                                </el-col>
                                <el-col :span="5" class="mb-4">
                                    <span class="col-element">{{ item.planning_criteria }}</span>
                                </el-col>
                                <el-col :span="5" class="mb-4 col-element" style="text-align: left;">
                                    <template v-if="item.order_type && item.order_type.length">
                                        <order-type-tag v-for="(orderTypeItem, orderTypeIndex) in item.order_type" :key="'orderTypeItem-'+orderTypeIndex">{{ orderTypeItem }}</order-type-tag>
                                    </template>
                                    <template v-else>
                                        &#8212;
                                    </template>
                                </el-col>
                                <el-col :span="5" class="mb-4">
                                    <template v-if="item.planning_criteria == 'transaction per hr' && item.transaction_per_hour && item.transaction_per_hour.length">
                                        <el-row :gutter="20" class="mb-1">
                                            <el-col :span="12" class="text-center"><b>Transaction</b></el-col>
                                            <el-col :span="12" class="text-center"><b>Manpower</b></el-col>
                                        </el-row>
                                        <el-row v-for="(transactionItem, transactionIndex) in item.transaction_per_hour" :key="'transaction_per_hour_'+transactionIndex" :gutter="20">
                                            <el-col :span="12" class="text-center">{{ transactionItem.range_start }} - {{ transactionItem.range_end }}</el-col>
                                            <el-col :span="12" class="text-center">{{ transactionItem.range_requirement }}</el-col>
                                        </el-row>
                                    </template>
                                    <template v-else-if="item.planning_criteria == 'quantity per hr' && item.quantitiy_per_hour && item.quantitiy_per_hour.length">
                                        <el-row :gutter="20" class="mb-1">
                                            <el-col :span="12" class="text-center"><b>Quantity</b></el-col>
                                            <el-col :span="12" class="text-center"><b>Manpower</b></el-col>
                                        </el-row>
                                        <el-row v-for="(quantityItem, quantityIndex) in item.quantitiy_per_hour" :key="'quantitiy_per_hour'+quantityIndex" :gutter="20">
                                            <el-col :span="12" class="text-center mb-2">{{ quantityItem.range_start }} - {{ quantityItem.range_end }}</el-col>
                                            <el-col :span="12" class="text-center mb-2">{{ quantityItem.range_requirement }}</el-col>
                                        </el-row>
                                    </template>
                                    <template v-else-if="item.planning_criteria == 'footfall per hr' && item.footfall_per_hour && item.footfall_per_hour.length">
                                        <el-row :gutter="20" class="mb-1">
                                            <el-col :span="12" class="text-center"><b>Footfall</b></el-col>
                                            <el-col :span="12" class="text-center"><b>Manpower</b></el-col>
                                        </el-row>
                                        <el-row v-for="(footfallItem, footfallIndex) in item.footfall_per_hour" :key="'footfall_per_hour'+footfallIndex" :gutter="20">
                                            <el-col :span="12" class="text-center mb-2">{{ footfallItem.range_start }} - {{ footfallItem.range_end }}</el-col>
                                            <el-col :span="12" class="text-center mb-2">{{ footfallItem.range_requirement }}</el-col>
                                        </el-row>
                                    </template>
                                    <template v-else-if="item.planning_criteria == 'item prep time per hr'">
                                        <template v-if="item.add_time_by.includes('Overall Average Time')">
                                            <el-row :gutter="20">
                                                <el-col :span="24" class="text-center mt-2">
                                                    <b>Overall Average Time</b>
                                                </el-col>
                                            </el-row>
                                            <el-row :gutter="20">
                                                <el-col :span="8" class="text-center mt-2">
                                                    <b>Hours</b>
                                                </el-col>
                                                <el-col :span="8" class="text-center mt-2">
                                                    <b>Mins</b>
                                                </el-col>
                                                <el-col :span="8" class="text-center mt-2">
                                                    <b>Seconds</b>
                                                </el-col>
                                            </el-row>
                                            <el-row :gutter="20">
                                                <el-col :span="8" class="text-center mb-2">
                                                    {{ item.prep_time_overall.hours }}
                                                </el-col>
                                                <el-col :span="8" class="text-center mb-2">
                                                    {{ item.prep_time_overall.minutes }}
                                                </el-col>
                                                <el-col :span="8" class="text-center mb-2">
                                                    {{ item.prep_time_overall.seconds }}
                                                </el-col>
                                            </el-row>
                                        </template>
                                        <template v-else-if="item.transaction_linked_activites && item.transaction_linked_activites.length">
                                            <el-row :gutter="20" class="mb-1">
                                                <el-col :span="12" class="text-center"><b>Transaction</b></el-col>
                                                <el-col :span="12" class="text-center"><b>(HH:MM:SS)</b></el-col>
                                            </el-row>
                                            <el-row v-for="(transacElement, transacIndex) in item.transaction_linked_activites" :key="'transac-link-item-'+transacIndex" :gutter="20" class="mb-1">
                                                <el-col :span="12" class="text-center">
                                                    {{ transacElement.name }}
                                                </el-col>
                                                <el-col :span="12" class="text-center">
                                                    {{ transacElement.hours }} : {{ transacElement.minutes }} : {{ transacElement.seconds }}
                                                </el-col>
                                            </el-row>
                                        </template>
                                        <template v-else>&nbsp;</template>
                                    </template>
                                    <template v-else>&nbsp;</template>
                                </el-col>
                                <el-col :span="2" class="mb-4">
                                    <div class="text-center">
                                        <span class="col-element">
                                            <span class="mr-4">
                                                <img
                                                    :class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
                                                    src="../../../../../assets/icons/edit-icon.svg"
                                                    width="12"
                                                    @click="isAdmin == 'admin' ? editUpdatedCoverageActivity(scope.row.section_id, index) : ''"
                                                />
                                            </span>
                                            <span>
                                                <img
                                                    :class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
                                                    src="../../../../../assets/icons/trash-icon.svg"
                                                    width="12"
                                                    @click="isAdmin == 'admin' ? removeUpdatedCoverageActivity(item) : ''"
                                                />
                                            </span>
                                        </span>
                                    </div>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="Section" prop="section_name"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        -->
        <el-row :gutter="20" class="mt-2">
            <el-col :span="24">
                <el-table :data="row_wise_company_coverage_activities" style="width: 100%" max-height="400">
                    <el-table-column label="Section" prop="section_name"></el-table-column>
                    <el-table-column label="Station / Function" prop="station_name">
                        <template slot-scope="scope">
                            <primary-tag>{{ scope.row.station_name }}</primary-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="Planning Type" prop="planning_criteria"></el-table-column>
                    <el-table-column label="Order Type">
                        <template slot-scope="scope">
                            <template v-if="scope.row.order_type && scope.row.order_type.length">
                                <order-type-tag v-for="(orderTypeItem, orderTypeIndex) in scope.row.order_type" :key="'orderTypeItem-'+orderTypeIndex">{{ orderTypeItem }}</order-type-tag>
                            </template>
                            <template v-else>
                                &#8212;
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="Activities">
                        <template slot-scope="scope">
                            <template v-if="scope.row.planning_criteria == 'transaction per hr' && scope.row.transaction_per_hour && scope.row.transaction_per_hour.length">
                                <el-row :gutter="20" class="mb-1">
                                    <el-col :span="12" class="text-center"><b>Transaction</b></el-col>
                                    <el-col :span="12" class="text-center"><b>Manpower</b></el-col>
                                </el-row>
                                <el-row v-for="(transactionItem, transactionIndex) in scope.row.transaction_per_hour" :key="'transaction_per_hour_'+transactionIndex" :gutter="20">
                                    <el-col :span="12" class="text-center">{{ transactionItem.range_start }} - {{ transactionItem.range_end }}</el-col>
                                    <el-col :span="12" class="text-center">{{ transactionItem.range_requirement }}</el-col>
                                </el-row>
                            </template>
                            <template v-else-if="scope.row.planning_criteria == 'quantity per hr' && scope.row.quantitiy_per_hour && scope.row.quantitiy_per_hour.length">
                                <el-row :gutter="20" class="mb-1">
                                    <el-col :span="12" class="text-center"><b>Quantity</b></el-col>
                                    <el-col :span="12" class="text-center"><b>Manpower</b></el-col>
                                </el-row>
                                <el-row v-for="(quantityItem, quantityIndex) in scope.row.quantitiy_per_hour" :key="'quantitiy_per_hour'+quantityIndex" :gutter="20">
                                    <el-col :span="12" class="text-center mb-2">{{ quantityItem.range_start }} - {{ quantityItem.range_end }}</el-col>
                                    <el-col :span="12" class="text-center mb-2">{{ quantityItem.range_requirement }}</el-col>
                                </el-row>
                            </template>
                            <template v-else-if="scope.row.planning_criteria == 'footfall per hr' && scope.row.footfall_per_hour && scope.row.footfall_per_hour.length">
                                <el-row :gutter="20" class="mb-1">
                                    <el-col :span="12" class="text-center"><b>Footfall</b></el-col>
                                    <el-col :span="12" class="text-center"><b>Manpower</b></el-col>
                                </el-row>
                                <el-row v-for="(footfallItem, footfallIndex) in scope.row.footfall_per_hour" :key="'footfall_per_hour'+footfallIndex" :gutter="20">
                                    <el-col :span="12" class="text-center mb-2">{{ footfallItem.range_start }} - {{ footfallItem.range_end }}</el-col>
                                    <el-col :span="12" class="text-center mb-2">{{ footfallItem.range_requirement }}</el-col>
                                </el-row>
                            </template>
                            <template v-else-if="scope.row.planning_criteria == 'item prep time per hr'">
                                <template v-if="scope.row.add_time_by.includes('Overall Average Time')">
                                    <el-row :gutter="20">
                                        <el-col :span="24" class="text-center mt-2">
                                            <b>Overall Average Time</b>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8" class="text-center mt-2">
                                            <b>Hours</b>
                                        </el-col>
                                        <el-col :span="8" class="text-center mt-2">
                                            <b>Mins</b>
                                        </el-col>
                                        <el-col :span="8" class="text-center mt-2">
                                            <b>Seconds</b>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="8" class="text-center mb-2">
                                            {{ scope.row.prep_time_overall.hours }}
                                        </el-col>
                                        <el-col :span="8" class="text-center mb-2">
                                            {{ scope.row.prep_time_overall.minutes }}
                                        </el-col>
                                        <el-col :span="8" class="text-center mb-2">
                                            {{ scope.row.prep_time_overall.seconds }}
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else-if="scope.row.transaction_linked_activites && scope.row.transaction_linked_activites.length">
                                    <el-row :gutter="20" class="mb-1">
                                        <el-col :span="12" class="text-center"><b>Transaction</b></el-col>
                                        <el-col :span="12" class="text-center"><b>(HH:MM:SS)</b></el-col>
                                    </el-row>
                                    <el-row v-for="(transacElement, transacIndex) in scope.row.transaction_linked_activites" :key="'transac-link-item-'+transacIndex" :gutter="20" class="mb-1">
                                        <el-col :span="12" class="text-center">
                                            {{ transacElement.name }}
                                        </el-col>
                                        <el-col :span="12" class="text-center">
                                            {{ transacElement.hours }} : {{ transacElement.minutes }} : {{ transacElement.seconds }}
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else>&nbsp;</template>
                            </template>
                            <template v-else>&nbsp;</template>
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <div class="text-center">
                            <span class="col-element">
                                <span class="mr-4">
                                    <img
                                        :class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
                                        src="../../../../../assets/icons/edit-icon.svg"
                                        width="12"
                                        @click="isAdmin == 'admin' ? editUpdatedCoverageActivity(scope.row.section_id, scope.row.main_index_value) : ''"
                                    />
                                </span>
                                <span>
                                    <img
                                        :class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
                                        src="../../../../../assets/icons/trash-icon.svg"
                                        width="12"
                                        @click="isAdmin == 'admin' ? removeUpdatedCoverageActivity(scope.row) : ''"
                                    />
                                </span>
                            </span>
                        </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- Add or edit coverage activities -->
        <add-or-edit-updated-coverage-activity></add-or-edit-updated-coverage-activity>
    </el-card>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
import AddOrEditUpdatedCoverageActivity from "./AddOrEditUpdatedCoverageActivity.vue";
import PrimaryTag from "./PrimaryTag.vue";
// import SecondaryTag from "./SecondaryTag.vue";
import OrderTypeTag from "./OrderTypeTag.vue";
export default {
    name: "AllUpdatedCoverageActivities",
    components: {
        AddOrEditUpdatedCoverageActivity,
        PrimaryTag,
        // SecondaryTag,
        OrderTypeTag,
    },
    mixins: [settingsMixin],
}
</script>

<style lang="scss">
/*
    .col-element {
        padding: 4px 10px;
        padding-top: 7px;
        font-size: 12px;
        line-height: 19px;
        text-align: center;
        text-transform: capitalize;
        margin-bottom: 4px;
        margin-right: 4px;
        display: inline-block;
    }
*/
.col-element {
    color: #606266;
    background: transparent;
    border-radius: 25px;
    padding: 4px 10px;
    padding-top: 7px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    text-align: center;
    text-transform: capitalize;
    border: 1px solid transparent;
    margin-bottom: 4px;
    margin-right: 4px;
    display: inline-block;
    .px-0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }
    padding-left: 0 !important;
}
</style>